module.exports = __webpack_public_path__ + "media/trio.46e2cbc2.ogg";